<app-dialog-container>
    <div fxLayout="column" class="modal-container">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <h2 mat-dialog-title>{{ title }}</h2>
        </div>

        <form [formGroup]="merchantForm" (ngSubmit)="onSubmit()"
            class="form-container">
            <div fxLayout="column" fxLayoutGap="12">
                <h3>Dados Gerais</h3>

                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column" fxLayoutGap="12">
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('tipoPessoa')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig(isPessoaJuridica ? 'numeroCnpj' : 'numeroCpf')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('nomeComerciante')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('nomeSocial')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('dataNascimento')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                </div>

                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column">
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%"
                        *ngIf="isPessoaJuridica" fxLayoutGap="12">
                        <div fxFlex fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('inscricaoEstadual')"
                                [group]="merchantForm">
                            </app-input>
                        </div>
                        <div fxFlex fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('inscricaoMunicipal')"
                                [group]="merchantForm">
                            </app-input>
                        </div>

                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutGap="12">
                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column" fxLayoutGap="12">
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('chavePix')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('celularFinanceiro')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('emailFinanceiro')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('email')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutGap="12">
                <h3>Endereço Geral</h3>

                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column" fxLayoutGap="12">
                    <div fxFlex fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%" fxLayoutGap="12">
                        <div fxFlex="15" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('cep')"
                                [group]="merchantForm"
                                (onChange)="onChangeCep()">
                            </app-input>
                        </div>

                        <div fxFlex="12" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('estado')"
                                [group]="merchantForm"
                                (onSelect)="onChangeState($event)">
                            </app-input>
                        </div>

                        <div fxFlex="30" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('cidade')"
                                [group]="merchantForm">
                            </app-input>
                        </div>

                        <div fxFlex="70" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('endereco')"
                                [group]="merchantForm">
                            </app-input>
                        </div>

                        <div fxFlex="12" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('numero')"
                                [group]="merchantForm">
                            </app-input>
                        </div>
                    </div>
                </div>

                <div fxLayout="column" fxLayoutGap="12">
                    <div fxLayout="row" fxLayoutWrap
                        fxLayout.lt-lg="column"
                        fxLayout.lt-md="column" fxLayoutGap="12">

                        <div fxFlex="20" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('bairro')"
                                [group]="merchantForm">
                            </app-input>
                        </div>

                        <div fxFlex fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('complemento')"
                                [group]="merchantForm">
                            </app-input>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutGap="12">
                <h3>Responsável Legal</h3>

                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column" fxLayoutGap="12">
                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelNome')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelCpf')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelRg')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelNacionalidade')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column" fxLayoutGap="12">

                    <div fxFlex="12" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelCelular')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex="25" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelEmail')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex="15" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelDataNascimento')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex="12" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelCep')"
                            [group]="merchantForm"
                            (onChange)="onChangeResponsavelCep()">
                        </app-input>
                    </div>

                    <div fxFlex="12" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelEstado')"
                            [group]="merchantForm"
                            (onSelect)="onChangeResponsavelState($event)">
                        </app-input>
                    </div>

                    <div fxFlex="20" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('responsavelCidade')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                </div>

                <div fxLayout="column" fxLayoutGap="12">
                    <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                        fxLayout.lt-md="column" fxLayoutGap="12">

                        <div fxFlex="40" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('responsavelEndereco')"
                                [group]="merchantForm">
                            </app-input>
                        </div>

                        <div fxFlex="12" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('responsavelNumero')"
                                [group]="merchantForm">
                            </app-input>
                        </div>

                        <div fxFlex="30" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('responsavelBairro')"
                                [group]="merchantForm">
                            </app-input>
                        </div>

                        <div fxFlex="30" fxFlex.lt-lg="1 1 100%"
                            fxFlex.lt-md="1 1 100%">
                            <app-input
                                [config]="getFieldConfig('responsavelComplemento')"
                                [group]="merchantForm">
                            </app-input>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutGap="12">
                <h3>Configurações</h3>

                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column" fxLayoutGap="12">

                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('idExterno')"
                            [group]="merchantForm">
                        </app-input>
                    </div>

                    <div fxFlex fxFlex.lt-lg="1 1 100%" fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('tipoConta')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutWrap fxLayout.lt-lg="column"
                    fxLayout.lt-md="column" fxLayoutGap="12">
                    <div fxFlex="20" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%">
                        <app-input
                            [config]="getFieldConfig('validarIp')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                    <div fxFlex="80" fxFlex.lt-lg="1 1 100%"
                        fxFlex.lt-md="1 1 100%" *ngIf="isValidarIp">
                        <app-input
                            [config]="getFieldConfig('ips')"
                            [group]="merchantForm">
                        </app-input>
                    </div>
                </div>
            </div>

            <mat-card fxLayout="row" fxLayoutAlign="end end"
                fxLayoutGap="16"
                class="form-actions">
                <button type="button" mat-stroked-button color="accent"
                    (click)="fillWithMockData()">
                    <mat-icon>auto_fix_high</mat-icon>
                    Dados de Teste
                </button>
                <div fxLayout="row" fxLayoutGap="16">
                    <button type="submit" mat-raised-button color="primary">
                        <span>Cadastrar Comerciante</span>
                    </button>
                </div>
            </mat-card>
        </form>
    </div>
</app-dialog-container>
